/** Created by azhou on 2019/3/13.*/
<template>
    <div>
      <group-chart-list v-if="isGroup && !storeId"/>
      <store-chart-lists v-else/>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupChartList from './GroupChartList'
  import StoreChartLists from './StoreChartLists'

  export default {
    name: 'GroupInvoiceBus',
    components: { StoreChartLists, GroupChartList },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
